'use strict';

module.exports.directive = [
  CommentIndicatorContainerDirective];

function CommentIndicatorContainerDirective() {
  return {
    restrict: 'A',
    controller: CommentIndicatorContainerController,
    compile: function ($element, attr) {
      return function ngEventHandler(scope, element, attrs, ctrl) {
        element.on('click', function (event) {
          if (ctrl.commentCtrl) {
            event.preventDefault();
            event.stopPropagation();
            scope.$apply(callback);
          }
          function callback() {
            ctrl.commentCtrl.showComments(event);
          }
        });

        scope.$on('$destroy', cleanup);

        function cleanup() {
          ctrl.unregister();
        }
      };
    }
  }
}

function CommentIndicatorContainerController() {
  this.commentCtrl = null;
}

CommentIndicatorContainerController.prototype.register = register;
CommentIndicatorContainerController.prototype.unregister = unregister;

function register(or) {
  this.commentCtrl = or;
}

function unregister() {
  this.commentCtrl = null;
}


// WEBPACK FOOTER //
// ./src/js/comments/directives/CommentIndicatorContainerDirective.js